module.exports = function(value, min, max) {
  return value <= min ? min : value >= max ? max : value;
}



// WEBPACK FOOTER //
// ./node_modules/@zaibot/mathlib/src/constrain.js